/**
 * Servicio del catálogo SAT para el gestor admin (rol Administrador).
 * El listado admin usa GET /api/admin/claves-sat (paginado + búsqueda
 * server-side) · el picker del wizard sigue con /api/catalogos/claves-sat
 * (listado completo · compartido con /solicitudes).
 */
import { axiosClient } from "@/shared/api/axios-client";
import type { ClaveSat } from "@/lib/types";

export interface ListarClavesSatParams {
  busqueda?: string;
  page?: number;
  pageSize?: number;
}

/** Envelope paginado del backend + total del catálogo completo para el header. */
export interface PaginaClavesSat {
  items: ClaveSat[];
  total: number;
  page: number;
  pageSize: number;
  totalCatalogo: number;
}

export async function listarClavesSatAdmin(
  params: ListarClavesSatParams = {}
): Promise<PaginaClavesSat> {
  const { data } = await axiosClient.get<PaginaClavesSat>(
    "/api/admin/claves-sat",
    { params }
  );
  return data;
}

export interface CrearClaveSatInput {
  clave: string;
  descripcion: string;
}

export async function crearClaveSat(input: CrearClaveSatInput): Promise<ClaveSat> {
  const { data } = await axiosClient.post<ClaveSat>("/api/admin/claves-sat", input);
  return data;
}

export async function editarClaveSat(
  clave: string,
  descripcion: string
): Promise<ClaveSat> {
  const { data } = await axiosClient.patch<ClaveSat>(
    `/api/admin/claves-sat/${encodeURIComponent(clave)}`,
    { descripcion }
  );
  return data;
}
